import { OrderPaymentOutcome } from './formatOrderPaymentNotificationText'

/**
 * Показывает системное уведомление о результате оплаты (только при granted).
 * @param params.title — заголовок
 * @param params.body — текст
 * @param params.orderId — id заказа (для tag)
 * @param params.outcome — успех / ошибка
 * @param params.onClick — колбэк по клику
 */
export const showPaymentStatusNotification = (params: {
  title: string
  body: string
  orderId: number
  outcome: OrderPaymentOutcome
  onClick?: () => void
}): void => {
  if (typeof Notification === 'undefined') {
    return
  }

  if (Notification.permission !== 'granted') {
    return
  }

  const { title, body, orderId, outcome, onClick } = params

  const notification = new Notification(title, {
    body,
    tag: `order-payment-${orderId}-${outcome}`,
    // Подсказка ОС: успех / ошибка (поддерживается не везде)
    ...(outcome === 'succeeded'
      ? { icon: '/logo192.png' }
      : { icon: '/logo192.png' }),
  })

  notification.onclick = () => {
    window.focus()
    onClick?.()
    notification.close()
  }
}
